export default __webpack_public_path__ + "img/42d72ef5e078e812c806ce9e0a8af1bf.png";